import { forwardRef } from "react";

import Icon from "@/components/Icon";
import CanvasSVG from "./CanvasSVG.svg.jsx";

const CanvasIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={CanvasSVG} {...props} />;
});

export default CanvasIcon;
